var render = function render(){var _vm=this,_c=_vm._self._c;return _c('status-indicator',{attrs:{"label":_vm.isInactive ? _vm.$t('base.inactive') : _vm.$t('base.active'),"color":_vm.isInactive ? _vm.INACTIVE_COLORS.background : _vm.ACTIVE_COLORS.background,"border-color":_vm.isInactive ? _vm.INACTIVE_COLORS.text : _vm.ACTIVE_COLORS.text}})
}
var staticRenderFns = []

export { render, staticRenderFns }